<article class="offer-status">

  <div *ngIf="data?.showProcessingDots" class="offer-status__dots" aria-label="Processing your application">
    <span class="offer-status__dot"></span>
    <span class="offer-status__dot offer-status__dot--delayed"></span>
    <span class="offer-status__dot offer-status__dot--late"></span>
  </div>

  <h1 class="offer-status__heading">{{ data?.heading }}</h1>

  <p class="offer-status__body">{{ data?.body }}</p>

  <a *ngIf="data?.showApplyCta && canApply"
     mat-flat-button
     color="primary"
     class="offer-status__apply"
     [href]="applyUrl"
     target="_blank"
     rel="noopener noreferrer">
    APPLY FOR FINANCING
  </a>

  <p *ngIf="showAdvisorContact" class="offer-status__contact">
    Call or email {{ application?.advisorName }} at&nbsp;<a class="offer-status__phone" [href]="'tel:' + contactPhone">{{ contactPhone | phone }}</a>
    or&nbsp;<a [href]="'mailto:' + application?.advisorEmail">{{ application?.advisorEmail }}</a> with any questions.
  </p>

  <p *ngIf="!showAdvisorContact" class="offer-status__contact offer-status__contact--company">
    Call us at&nbsp;<a class="offer-status__phone" [href]="'tel:' + contactPhone">{{ contactPhone | phone }}</a>
    or email us at&nbsp;<a [href]="'mailto:' + fallbackEmail">{{ fallbackEmail }}</a> with any questions.
  </p>

</article>
